import { render, staticRenderFns } from "./importAddFees.vue?vue&type=template&id=038c9e1a&scoped=true"
import script from "./importAddFees.vue?vue&type=script&lang=js"
export * from "./importAddFees.vue?vue&type=script&lang=js"
import style0 from "./importAddFees.vue?vue&type=style&index=0&id=038c9e1a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c9e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038c9e1a')) {
      api.createRecord('038c9e1a', component.options)
    } else {
      api.reload('038c9e1a', component.options)
    }
    module.hot.accept("./importAddFees.vue?vue&type=template&id=038c9e1a&scoped=true", function () {
      api.rerender('038c9e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/feesPayable/ImportCmp/importAddFees.vue"
export default component.exports